{% block moorl_page_detail %}
    <sw-card-view class="moorl-page-detail">
        <moorl-form
            :item="item"
            :entity="entity"
            :componentName="componentName"
        />
    </sw-card-view>
{% endblock %}